/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { DatePicker as DP, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useSnackbar } from "notistack";
import moment from "moment";

const DatePicker = ({format="", disableFuture=false, handleChange, notBeforeToday = false, size = "medium", value = new Date(), disablePast = false, error = false, disabled = false, fullWidth = false, views = null, inputProps = {}, openTo = null, maxDate = null, name = ""}) => {
    const [selectedDate, setSelectedDate] = useState(value);
    const [dayAfterMin, setDayAfterMin] = useState(new Date(1990, 1, 1));
    useEffect(() => {
        if(notBeforeToday) {
            const date = new Date();
            date.setDate(date.getDate() + 1);
            setDayAfterMin(date);
            setSelectedDate(date);
        }
        if(value.toString()=== "Invalid Date"){
            setSelectedDate(new Date());
        } else{
            setSelectedDate(value);
        }
    }, []);

    useEffect(() => {
        handleChange(selectedDate);
    }, [selectedDate]);

    const { enqueueSnackbar } = useSnackbar();

    const handleDaysAfterToday = (date) => {
        if(moment(date).isAfter(moment())){
            handleChange(date);
        } else {
            enqueueSnackbar("Please enter the date after today", {variant: "error"});
        }
    };

    const handleAnyDays = (date) => {
        handleChange(date);
    };

    const changeHandler = date => {
        setSelectedDate(date);
        notBeforeToday ? handleDaysAfterToday(date) : handleAnyDays(date);
    };

    return(
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DP
                autoOk
                name={name}
                views={views || ["date"]}
                inputVariant="outlined"
                size={size as "medium" || "small"}
                value={selectedDate}
                disablePast={disablePast}
                minDate={dayAfterMin}
                format={format || ""}
                onChange={changeHandler}
                disableFuture={disableFuture}
                error={error}
                disabled={disabled}
                fullWidth={fullWidth}
                InputProps={inputProps}
                maxDate={maxDate || new Date("2100-01-01")}
                openTo={openTo || "date"}
            />
        </MuiPickersUtilsProvider>
    );
};



export default DatePicker;
